<div class="row">
  <div class="secondary-details col-sm-6 my-2">
    <span>{{
      'mapping.specifications.invoiceSpecificationList.invoiceSpecifications' | translate
    }}</span>
  </div>
  <div class="col-sm-6 text-end">
    <button
      class="me-1 icon-mat"
      (click)="createSpecification()"
      #tooltip="matTooltip"
      matTooltip="{{
        'mapping.specifications.invoiceSpecificationList.createSpecification' | translate
      }}"
      mat-raised-button>
      <em class="bi bi-plus"></em>
    </button>

    <button
      class="me-1 icon-mat"
      (click)="openUploadSpecification()"
      #tooltip="matTooltip"
      matTooltip="{{
        'mapping.specifications.invoiceSpecificationList.uploadSpecification' | translate
      }}"
      mat-raised-button>
      <em class="bi bi-upload"></em>
    </button>
  </div>
</div>

<div class="row py-2 sub-action">
  <div class="col-sm-6 search-bar-group">
    <input
      matInput
      [(ngModel)]="searchTerm"
      (keyup)="searchSpecification(searchTerm)"
      placeholder="{{
        'mapping.specifications.invoiceSpecificationList.searchSpecification' | translate
      }}" />
  </div>

  <div class="col-sm-6 text-end">
    <button
      *ngIf="showDeleteButton"
      class="icon-mat"
      (click)="deleteSpecification()"
      [matBadge]="specDeletionList?.length"
      matBadgeOverlap="true"
      matBadgeSize="small"
      matTooltip="{{
        'mapping.specifications.invoiceSpecificationList.delete'
          | translate : { value: specDeletionList?.length }
      }}"
      mat-raised-button>
      <i class="bi bi-trash"></i>
    </button>
  </div>
</div>

<div class="spec-table-container py-2">
  <app-invoice-specification-table
    [searchTerm]="searchTermValue"
    (downloadSpec)="downloadTemplateExcel($event)"
    (editSpecEvent)="editSpecEvent($event)">
  </app-invoice-specification-table>
</div>
